module.exports = __webpack_public_path__ + "static/intercomlogo-f243c1755229d5cfe9f83be748c6a5cb.svg";